// extracted by mini-css-extract-plugin
export default {"titleWrap":"titleWrap---zdYC2","title":"title---mSky4"};